import { FC, ReactNode, useRef, useState } from "react"
import { Image } from "@/components/common/Image"
import { FormattedMessage } from "react-intl"
import { arrow, autoPlacement, FloatingArrow, offset, shift, useDismiss, useFloating, useInteractions } from "@floating-ui/react"

type HelpNoteProps = {
  children: ReactNode
}

export const HelpNote: FC<HelpNoteProps> = ({ children }: HelpNoteProps) => {
  const [open, setOpen] = useState(false)
  const arrowRef = useRef<SVGSVGElement | null>(null)
  const { refs, floatingStyles, context } = useFloating({
    open,
    onOpenChange: setOpen,
    placement: "right-start",
    middleware: [
      autoPlacement({ }),
      offset(10),
      shift({padding:10}),
      arrow({
        element: arrowRef,
        padding: 10,
      }),
    ],
  })
  const dismiss = useDismiss(context)
  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss])
  return (
    <>
      <button
        ref={refs.setReference}
        {...getReferenceProps()}
        className="button-reset dropdown-toggle no-arr welcome-info__tooltips"
        type="button"
        onClick={() => setOpen(!open)}
      >
        <Image src="help-d.svg" />
      </button>
      {open && (
        <div ref={refs.setFloating} style={floatingStyles} className="bg-white z-[1000] shadow-lg" {...getFloatingProps()}>
          <FloatingArrow ref={arrowRef} context={context} className="text-white" fill="white" startOffset={10} />
        
          <div className="tooltips-ver__body">
            <h4 className="h4 tooltips-ver__title">
              <FormattedMessage id="note" />
            </h4>
            {children}
          </div>
        </div>
      )}
    </>
  )
}
